import { Stat } from '@/components/ui/Stat';
import { useCommunicationCounts } from '@/hooks/useAdminCommunications';
import { formatNumber } from '@/utils/formatters';
import { AlertTriangle, Wrench, Megaphone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { CommunicationHistory } from '../components/CommunicationHistory';

export function CommunicationsPage() {
  const { data: counts } = useCommunicationCounts();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Communications</h1><p className="text-sm text-neutral-500">Gestion des communications plateforme</p></div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Link to="/communications/incidents">
          <Stat label="Incidents" value={formatNumber(counts?.incidents)} icon={<AlertTriangle className="h-5 w-5" />} className="cursor-pointer hover:border-primary-500/50 transition-colors" />
        </Link>
        <Link to="/communications/maintenance">
          <Stat label="Maintenances" value={formatNumber(counts?.maintenances)} icon={<Wrench className="h-5 w-5" />} className="cursor-pointer hover:border-primary-500/50 transition-colors" />
        </Link>
        <Link to="/communications/announcements">
          <Stat label="Annonces" value={formatNumber(counts?.announcements)} icon={<Megaphone className="h-5 w-5" />} className="cursor-pointer hover:border-primary-500/50 transition-colors" />
        </Link>
        <Link to="/communications/emails">
          <Stat label="Campagnes email" value={formatNumber(counts?.emailCampaigns)} icon={<Mail className="h-5 w-5" />} className="cursor-pointer hover:border-primary-500/50 transition-colors" />
        </Link>
      </div>

      <div className="flex gap-2">
        <Link to="/communications/incidents"><Button variant="outline" size="sm">Incidents</Button></Link>
        <Link to="/communications/maintenance"><Button variant="outline" size="sm">Maintenance</Button></Link>
        <Link to="/communications/announcements"><Button variant="outline" size="sm">Annonces</Button></Link>
        <Link to="/communications/emails"><Button variant="outline" size="sm">Emails</Button></Link>
      </div>

      <CommunicationHistory />
    </div>
  );
}
